import { AnalyticsDataFrameLineChartController } from './analytics-data-frame-line-chart.controller'

function analyticsDataFrameLineChart () {
  return {
    restrict: 'E',
    scope: {
      data: '<',
      filterParams: '<',
      slug: '<',
      loadingDataFrames: '=',
      noEmptyModeDescription: '<',
      fullWidth: '<'
    },
    templateUrl: '/analytics/directives/analytics-data-frame-line-chart/analytics-data-frame-line-chart-directive.html?$$REVISION$$',
    controller: AnalyticsDataFrameLineChartController
  }
}

export { analyticsDataFrameLineChart }
